// ============================================================================
// Service: Lifecycle Report API
// ============================================================================

import axiosClient from "../../../../../../api/axiosClient";

export const fetchLifecycleReport = async (filters) => {

  const params = new URLSearchParams(filters).toString();

  const response = await axiosClient.get(
    `/api/ppe/reports/lifecycle/detail?${params}`
  );

  return response.data;
};